import { AssigneeGroup, UsersStatusType, StatusFiltersType } from './types';

export const ASSIGNEE_PICKER_COMPANY = 'company';
export const ASSIGNEE_PICKER_ROLE = 'role';
export const ASSIGNEE_PICKER_USER = 'user';
export const ASSIGNEE_PICKER_UNASSIGNED = 'unassigned';

export const DEFAULT_OPTIONS_ORDER: AssigneeGroup[] = [
  ASSIGNEE_PICKER_USER,
  ASSIGNEE_PICKER_COMPANY,
  ASSIGNEE_PICKER_ROLE,
];

export const DEFAULT_STATUS_FILTERS = {
  users: ['active', 'deleted'],
  roles: ['active', 'inactive'],
  companies: ['active'],
} satisfies StatusFiltersType;

export const AUTODESK_ID_VALUE_KEY = 'autodeskId';
export const MEMBER_GROUP_ID_VALUE_KEY = 'memberGroupId';

export const DEFAULT_USERS_STATUS_FILTER: UsersStatusType[] = [
  'active',
  'pending',
  'disabled',
  'deleted',
];

export const ASSIGNEE_PICKER_RECENTS = 'recents';

export const RECENTS_DEFAULT_MAX_LENGTH = 5;
export const RECENTS_DEFAULT_MIN_TO_SHOW = 3;

export const LOADING_STYLE = {
  '> div': {
    minHeight: 468,
  },
};
